import styled from "styled-components";

const Button = styled.button``;

export default Button;
